import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const systemCurrencyEntity: Entity = {
  model: model,
  repository: repository,
}

export default systemCurrencyEntity
